import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/userContext';
import './styles/main.scss';
import './i18n';
import { SelectionProvider } from './context/selectionContext';
import { BuildingProvider } from './context/buildingContext';
import { RoomsProvider } from './context/RoomsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UserProvider>
      <SelectionProvider>
        <BuildingProvider>
          <RoomsProvider>
            <App />
          </RoomsProvider>
        </BuildingProvider>
      </SelectionProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
